import React, { Component } from "react";
import { Link } from "react-router-dom";

class JobImpressum extends Component {

  componentDidMount() {
    window.scrollTo(0, 0);
    document.title = "Impressum | ZoneAid.io";
  }

  renderFooter() {
    return (
      <div className="mt-auto border-top px-4 py-4 text-center text-muted small">
        <div className="d-flex justify-content-center gap-3 flex-wrap">
          <Link target="_blank" rel="noopener noreferrer" to="/job/impressum" className="text-dark text-decoration-underline small">Impressum</Link>
          <Link target="_blank" rel="noopener noreferrer" to="/job/agb" className="text-dark text-decoration-underline small">Nutzungsbedingungen</Link>
        </div>
        <div className="mt-2">
          <Link target="_blank" rel="noopener noreferrer" to="/job/datenschutz" className="text-dark text-decoration-underline small">Datenschutzerklärung</Link>
        </div>
      </div>
    );
  }

  render() {
    return (
      <div className="d-flex flex-column min-vh-100 bg-white" style={{ maxWidth: 480, margin: '0 auto' }}>

        <div className="px-4 py-4 flex-grow-1">
          <h2 className="fw-bold mb-1">Impressum</h2>
          <p className="text-muted small mb-4">
            Angaben gemäß §5 E-Commerce-Gesetz (ECG) und Offenlegung gemäß §25 Mediengesetz
          </p>

          <section className="mb-4">
            <h5 className="fw-bold">ZoneAid.io (Renolition Inc.)</h5>
            <p className="small mb-1">Eine nach dem Recht des US-Bundesstaates Delaware gegründete Gesellschaft (Corporation)</p>
            <p className="small mb-1">Unternehmensgegenstand: Online-Marketing- und Recruiting-Dienstleistungen</p>
            <p className="small mb-1">Registrierungsstaat: Delaware, USA</p>
            <p className="small mb-0">Registernummer (Delaware Division of Corporations): 6197486</p>
          </section>

          <section className="mb-4">
            <h5 className="fw-bold">Firmensitz / Registered Address</h5>
            <p className="small mb-1">ZoneAid.io (Renolition Inc.)</p>
            <p className="small mb-1">315 Montgomery St</p>
            <p className="small mb-0">San Francisco, CA 94104, USA</p>
          </section>

          <section className="mb-4">
            <h5 className="fw-bold">Kontakt</h5>
            <p className="small mb-1">Telefon: +1 415 745 2240</p>
            <p className="small mb-0">E-Mail: support@renolition.com</p>
          </section>

          <section className="mb-4">
            <h5 className="fw-bold">Vertretungsberechtigte Person</h5>
            <p className="small mb-0">Seyed Taleghani, CEO</p>
          </section>

          <section className="mb-4">
            <h5 className="fw-bold">Hinweis zur Tätigkeit</h5>
            <p className="small text-muted">
              Die auf dieser Website (www.zoneaid.io) beworbenen Stellenangebote werden im Auftrag des jeweils
              genannten Personalvermittlungs- bzw. einstellenden Unternehmens veröffentlicht. Verantwortlich für
              die jeweilige Stellenausschreibung ist das im Rahmen des Bewerbungsprozesses genannte Unternehmen.
            </p>
          </section>

          <section className="mb-4">
            <h5 className="fw-bold">Beschwerden</h5>
            <p className="small text-muted">
              Sie können Beschwerden an die oben angegebene E-Mail-Adresse richten.
            </p>
          </section>

          <section className="mb-4">
            <h5 className="fw-bold">Haftungsausschluss</h5>
            <p className="small text-muted">
              Dieser Haftungsausschluss ist als Teil des Internetangebotes zu betrachten, von dem aus auf diese
              Webseite verwiesen wurde. Sofern Teile oder einzelne Formulierungen dieses Textes der geltenden
              Rechtslage nicht, nicht mehr oder nicht vollständig entsprechen sollten, bleiben die übrigen Teile
              des Dokumentes in ihrem Inhalt und ihrer Gültigkeit davon unberührt.
            </p>
          </section>

          <section className="mb-4">
            <h5 className="fw-bold">Haftung für Inhalte dieser Webseite</h5>
            <p className="small text-muted">
              Die Inhalte dieser Webseite wurden mit größtmöglicher Sorgfalt erstellt. Für die Richtigkeit,
              Vollständigkeit und Aktualität der Inhalte übernehmen wir jedoch keine Gewähr. Als Diensteanbieter
              sind wir für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Wir sind
              jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder
              nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen. Verpflichtungen zur
              Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon
              unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten
              Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese
              Inhalte umgehend entfernen.
            </p>
          </section>

          <section className="mb-4">
            <h5 className="fw-bold">Haftung für Links auf Webseiten Dritter</h5>
            <p className="small text-muted">
              Unser Angebot enthält Links zu externen Websites. Auf den Inhalt dieser externen Webseiten haben wir
              keinerlei Einfluss. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für
              die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten
              verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche
              Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar.
              Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte
              einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige
              Links umgehend entfernen.
            </p>
          </section>

          <section className="mb-4">
            <h5 className="fw-bold">Urheberrecht</h5>
            <p className="small text-muted">
              Die Betreiber dieser Webseite sind bemüht, stets die Urheberrechte anderer zu beachten bzw. auf
              selbst erstellte sowie lizenzfreie Werke zurückzugreifen. Die durch die Seitenbetreiber erstellten
              Inhalte und Werke auf dieser Webseite unterliegen dem Urheberrecht. Beiträge Dritter sind als solche
              gekennzeichnet. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb
              der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw.
              Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch
              gestattet.
            </p>
          </section>
        </div>

        {this.renderFooter()}
      </div>
    );
  }
}

export default JobImpressum;
